import { useState } from 'react';
import { translateFault, generateUnhandledFault } from '../../helpers/faults';
import {
  currency3DS_url,
  environment,
} from '../../constants/checkout.constant';
import axios from 'axios';

function useConfigCurrencyJSON() {
  const [fault, setFault] = useState(null);
  const [configCurrency, setConfigCurrency] = useState('');
  const [env, setEnv] = useState('');

  const getCurrency3DSurl = (envURL) => {
    let currency3DSurl, env;
    if (envURL.indexOf('prd3') >= 0) {
      currency3DSurl = currency3DS_url.PRD;
      env = environment.PRD;
    } else if (envURL.indexOf('prf2') >= 0) {
      currency3DSurl = currency3DS_url.PRF;
      env = environment.PRF;
    } else {
      currency3DSurl = currency3DS_url.SBX;
      env = environment.SBX;
    }
    return { currency3DSurl, env };
  };

  const requestConfigCurrencyJSON = async () => {
    const envURL = ASCENDON_ENV_CONFIG.apiUrl;
    const { currency3DSurl, env } = getCurrency3DSurl(envURL);
    try {
      const result = await axios.get(currency3DSurl);
      const currency = result?.data;
      setConfigCurrency({
        currency,
      });
      setEnv(env);
    } catch (error) {
      console.warn({ error });
      const code = error?.data?.Code;
      let errorMsg;
      if (!code) {
        const unknownFault = generateUnhandledFault(error.data);
        errorMsg = translateFault(unknownFault).translatedMessage;
        setFault(errorMsg);
      } else {
        errorMsg = translateFault(error.data).translatedMessage;
        setFault(errorMsg);
      }
    }
  };

  return [configCurrency, env, fault, requestConfigCurrencyJSON];
}

export { useConfigCurrencyJSON };
export default useConfigCurrencyJSON;
